// Lightweight offline cache for the user's emergency / medical-card data so the
// Emergency and Medical ID screens still open with no signal.
const KEY = "pd_emergency_cache";

export function cacheEmergency(data) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ data, savedAt: new Date().toISOString() }));
  } catch (_) {}
}

export function readEmergency() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}

// Per-trip Confidence Report cache (trip + report), keyed by trip id.
export function cacheReport(tripId, trip, report) {
  try {
    const prev = readReport(tripId);
    localStorage.setItem(
      "pd_report_" + tripId,
      JSON.stringify({ trip: trip || prev?.trip || null, report, savedAt: new Date().toISOString() })
    );
  } catch (_) {}
}

export function readReport(tripId) {
  try {
    const raw = localStorage.getItem("pd_report_" + tripId);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
}
